export enum EOfferScopeCapType {
	cumulative = 'cumulative',
	daily = 'daily',
}

export const OFFER_SCOPE_CAP_TYPE_LABEL_MAP: Record<EOfferScopeCapType, string> = {
	[EOfferScopeCapType.cumulative]: `offer_scope_cap_type.${EOfferScopeCapType.cumulative}`,
	[EOfferScopeCapType.daily]: `offer_scope_cap_type.${EOfferScopeCapType.daily}`,
}